<template>
    <div class="mt-4 border" v-if="!isLogin" data-cy="container_form_login">
        <div class="max-w-md m-auto p-4">
            <div class="text-center text-lg font-bold mb-2" data-cy="text_form_login_title">Login</div>
            <InputText
                    class="mb-3"
                    v-model:inputValue="modelLogin.username"
                    txtLabel="Username"
                    txtPlaceholder="Usename"
                    data-cy="input_form_login_username"
            ></InputText>
            <InputPassword
                    class="mb-3"
                    v-model:inputValue="modelLogin.password"
                    txtLabel="Password"
                    txtPlaceholder="Password"
                    data-cy="input_form_login_password"
            ></InputPassword>
            <div class="text-center">
                <button class="bg-blue-500 text-white py-1 px-2 rounded-md" @click="submitLogin()" data-cy="btn_form_login_submit">Login</button>
            </div>
        </div>
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
//component
import InputText from "@/components/Input/simple/InputText.vue";
import InputPassword from "@/components/Input/simple/InputPassword.vue";
//service
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
import { AuthLoginConfigBuilder } from "@/core/Account/config/AuthConfigModel.js"
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";

export default {
    name: "FormLogin",
    mixins: [AuthStatusMixin],
    props: {
        modalController: Object,
    },
    components: {
        InputText,
        InputPassword,
    },
    data: function() {
        return {
            modelLogin: {
                username: "aaabbbccc",
                password: "11111111"
            },
        };
    },
    methods: {
        submitLogin: function() {
            // validate
            this.sendApiLogin();
        },
        sendApiLogin: function() {
            let loginParams = new AuthLoginConfigBuilder()
                        .setUsername(this.modelLogin.username)
                        .setPassword(this.modelLogin.password)
                        .create()
                        .getParams();

            this.modalController.loadingModal.show();
            BzbsAuth.apiLogin(loginParams).subscribe({
                next: (data) => {
                    console.log("login", data);
                    this.loginSuccess(data);
                },
                error: (err) => {
                    this.modalController.loadingModal.hide();

                    if (err.id == 403) {
                        this.modalController.alertModal
                            .clearModal()
                            .setMsg("Account ถูกแบน กรณาติดต่อ call center")
                            .show();
                    } else {
                        this.errorApi(err)
                    }

                    console.log(err);
                }
            });
        },
        loginSuccess: function(user) {
            Account.setCacheUser(user);
            window.location.reload();
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
